import { AdminHome } from '../AdminHome/router/AdminHome.routes'

export const Admin = [{
  path: '/Admin',
  component: () => import('./Admin.vue'),
  meta: {
    crumbName: '管理后台'
  },
  children: [
    ...AdminHome,
    {
      path: 'Login',
      name: '登录',
      component: () => import('../login.vue')
    }
  ]
}]


// WEBPACK FOOTER //
// ./src/pages/Admin/router/Admin.routes.js